import React, { useEffect, useState, useRef, useCallback } from 'react'
import { styled } from 'linaria/react'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'
import { SiteContext } from '../../Global/SiteContext'
import { useContext } from 'react'
import { theme } from '../../Theme'
import {
   getStickersFromProductSettings,
   isProductPrebook,
   isArrayWithItems,
   extractStrBeforeQuestionMark,
   setLangLinkRoutes,
} from '../../Core/Util/Helpers'
import ProductPageImageSkeleton from '../../Core/Skeletons/ProductPageImageSkeleton'
import Image from '@jetshop/ui/Image/Image'
import { OpenInWindow, Cancel } from 'iconoir-react'
import { ProductGridVideo } from './ProductGridVideo'
import { useIsAboveMd } from '../../../components/Core/Hooks/mediaQueryHooks'
import { Play } from 'iconoir-react'
import { PrisJaktWidget } from './PrisJaktWidgets'
import Link from '../../Core/Link'

const ImageGalleryWrapper = styled.div`
   z-index: ${props => (props?.globalFullscreen ? '1021' : 'unset')} !important;

   & {
      position: relative;
      max-width: 960px;
   }

   & .sticker-container {
      position: absolute;
      top: 0;
      right: 0;
      justify-content: flex-end;
      @media screen and (min-width: 500px) {
         height: 3rem;
      }
      ${theme.above.lg} {
         height: 2.4rem;
      }
      ${theme.above.xxl} {
         height: 3rem;
      }
      ${theme.above.xxxl} {
         height: 4rem;
      }
   }

   .price-runner,
   .prisjakt-wrapper img {
      height: 26px;
      @media screen and (min-width: 500px) {
         height: 2.2rem;
      }
      ${theme.above.lg} {
         height: 1.8rem;
      }
      ${theme.above.xxl} {
         height: 2.2rem;
      }
      ${theme.above.xxxl} {
         height: 2.9rem;
      }
   }

   .image-gallery-image {
      aspect-ratio: 1/1;
      object-fit: contain !important;
   }

   .image-gallery-thumbnail-image {
      aspect-ratio: 1/1;
      object-fit: cover !important;
   }

   .image-gallery-svg {
      width: ${props => (props?.globalFullscreen ? '2rem' : '3rem')};
      height: ${props => (props?.globalFullscreen ? '2rem' : '3rem')};
      ${theme.above.sm} {
         width: 3.5rem;
         height: 3.5rem;
      }
   }

   .image-gallery-thumbnail.active,
   .image-gallery-thumbnail:focus {
      border: 4px solid var(--color-vb-blue);
   }

   .img-fluid-height {
      height: 100%;
      @media screen and (min-width: 500px) {
         height: 70%;
      }
   }

   .image-gallery-left-nav,
   .image-gallery-right-nav {
      padding: 0px;
      /* ${theme.above.md} {
         padding: 0px 10px;
      } */
   }

   .image-gallery-slides {
   }

   .video-wrapper {
      cursor: ${props =>
         props?.globalFullscreen ? 'zoom-out' : 'zoom-in'} !important;
      margin: ${props =>
         props?.globalFullscreen ? '5% 0px' : '7% 0px 13% 0px'} !important;
      /* props?.globalFullscreen ? '5% 0px' : '10% 10% 25% 10%'} !important; */

      ${theme.above.xl} {
         margin: ${props =>
            props?.globalFullscreen ? '0% 20%' : '7% 0px 13% 0px'} !important;
      }
   }

   .image-gallery-bullets {
      bottom: -2rem;
   }

   .image-gallery-bullet {
      ${theme.below.md} {
         padding: 5px !important;
      }
   }

   .custom-image[data-flight-image-container] {
      cursor: ${props =>
         props?.globalFullscreen ? 'zoom-out' : 'zoom-in'} !important;

      padding-bottom: ${props =>
         props?.globalFullscreen ? '0' : '100%'} !important;
      height: ${props =>
         props?.globalFullscreen
            ? 'clamp(100px,80vh,1280px'
            : '100%'} !important;
   }

   .custom-image > [data-flight-image] img {
      margin-top: 0px !important;
      padding: ${props => (props?.globalFullscreen ? '0px' : '1px')} !important;
   }

   .custom-fullscreen-btn {
      position: absolute;
      right: 0;
      top: ${props => (props?.globalFullscreen ? '0px' : 'unset')} !important;
      bottom: ${props => (props?.globalFullscreen ? 'unset' : '1%')} !important;
      padding: 0px 15px 15px 15px;
      cursor: pointer;

      & :hover {
         color: #337ab7;
         -webkit-transition: 0.3s;
         transition: 0.3s;
      }
   }
   .icon-shadow {
      -webkit-filter: drop-shadow(0 2px 2px #1a1a1a);
      filter: drop-shadow(0 2px 2px #1a1a1a);
      height: clamp(2.4rem, 4.5vw, 2.9rem);
      width: clamp(2.4rem, 4.5vw, 2.9rem);
   }

   .video-wrapper .video-title {
      display: ${props =>
         props?.globalFullscreen ? 'none' : 'block'} !important;
   }

   .video-thumb [data-flight-image-children] {
      position: absolute !important;
      z-index: 2 !important;
      width: auto !important;
      height: auto !important;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
   }

   .sticker-route-link {
      &:hover {
         opacity: 0.8;
      }
   }
`

function ProductImageGallery({
   loading,
   product,
   productSettings,
   selectedChannelId,
   ...props
}) {
   const [galleryItems, setGalleryItems] = useState(null)
   const { activeVariant, productInformation } = useContext(SiteContext)
   const {
      campaignSticker,
      newSticker,
      packageSticker,
      preBookCampaignSticker,
   } = getStickersFromProductSettings(productSettings)
   const onSale = activeVariant?.onSale ?? false
   const isNew = activeVariant?.isNew ?? false
   const isPackage = activeVariant?.isPackage
   // const isPrebook = activeVariant?.stockStatus?.stockStatusId == '14'
   const [mediaArr, setMediaArr] = useState(null)
   const [globalFullscreen, setGlobalFullscreen] = useState(false)
   const imageGalleryRef = useRef(null)
   const isDesktop = useIsAboveMd()

   useEffect(() => {
      const youtubeVideosData = isArrayWithItems(productInformation?.videos)
         ? productInformation.videos.map(video => {
              const { Title, Value: videoId = 'unknown' } = video ?? {}
              const extractedVideoId = extractStrBeforeQuestionMark(videoId)
              return {
                 title: Title,
                 videoId,
                 thumbUrl: `https://img.youtube.com/vi/${extractedVideoId}/default.jpg?`,
              }
           })
         : []
      const videosPosition = 3
      const videoSliceIndex = 2
      const images = activeVariant?.images ?? []
      const videos = youtubeVideosData?.slice(0, videoSliceIndex) ?? []

      setMediaArr([
         ...images.slice(0, videosPosition),
         ...videos,
         ...images.slice(videosPosition),
      ])
   }, [activeVariant?.images, productInformation?.videos])

   function handleFullscreen(event) {
      if (
         imageGalleryRef.current.state.isFullscreen === undefined ||
         imageGalleryRef.current.state.isFullscreen === null
      ) {
         return
      }

      if (imageGalleryRef.current.state.isFullscreen === true) {
         imageGalleryRef.current.exitFullScreen()
         document.body.classList.toggle('prevent-body-scroll', false)
         setGlobalFullscreen(false)
      } else {
         imageGalleryRef.current.fullScreen()
         document.body.classList.toggle('prevent-body-scroll', true)
         setGlobalFullscreen(true)
      }
   }

   useEffect(() => {
      // Remove prevent-body-scroll when comp unmounts, secure scroll on body
      return () => {
         document.body.classList.remove('prevent-body-scroll')
      }
   }, [])

   useEffect(() => {
      if (!mediaArr) {
         return
      }
      const timestamp = Math.floor(Date.now() / 1000)
      const convertedMediaItems =
         mediaArr?.map(mediaItem => {
            const isVideoItem = mediaItem?.videoId
            const originalUrl = isVideoItem
               ? `https://img.youtube.com/vi/${mediaItem.videoId}/hqdefault.jpg?`
               : mediaItem?.url
            const thumbnailUrl = isVideoItem
               ? mediaItem?.thumbUrl
               : mediaItem?.url
            const originalAlt = isVideoItem ? mediaItem?.title : mediaItem?.alt
            const thumbnailAlt = isVideoItem ? mediaItem?.title : mediaItem?.alt
            const originalTitle = isVideoItem
               ? mediaItem?.title
               : mediaItem?.title
            if (isVideoItem) {
               return {
                  original: originalUrl,
                  thumbnail: thumbnailUrl,
                  originalAlt: originalAlt,
                  thumbnailAlt: thumbnailAlt,
                  originalTitle: originalTitle,
                  renderItem: () => (
                     <div className="video-wrapper">
                        <ProductGridVideo
                           title={originalTitle}
                           videoId={mediaItem.videoId}
                        ></ProductGridVideo>
                     </div>
                  ),
                  renderThumbInner: () => (
                     <Image
                        className="video-thumb"
                        src={thumbnailUrl}
                        alt={thumbnailAlt}
                        aspect="1:1"
                        critical={true}
                        quality={20}
                        modifiedDate={timestamp}
                     >
                        <Play
                           color={'#FFFFFF00'}
                           fill={'#FFFFFFE6'}
                           width={'100%'}
                           height={'100%'}
                        />
                     </Image>
                  ),
               }
            } else {
               return {
                  original: originalUrl,
                  thumbnail: thumbnailUrl,
                  originalAlt: originalAlt,
                  thumbnailAlt: thumbnailAlt,
                  originalTitle: originalTitle,
                  renderItem: () => (
                     <Image
                        className="custom-image"
                        src={originalUrl}
                        alt={originalAlt}
                        aspect="1:1"
                        critical={true}
                        modifiedDate={timestamp}
                     ></Image>
                  ),
                  renderThumbInner: () => (
                     <Image
                        src={thumbnailUrl}
                        alt={thumbnailAlt}
                        aspect="1:1"
                        critical={true}
                        quality={20}
                        modifiedDate={timestamp}
                     ></Image>
                  ),
               }
            }
         }) ?? []

      if (convertedMediaItems?.length > 0) {
         setGalleryItems(convertedMediaItems)
      }
   }, [setGalleryItems, mediaArr])

   return galleryItems && activeVariant ? (
      <ImageGalleryWrapper {...props} globalFullscreen={globalFullscreen}>
         <ImageGallery
            ref={imageGalleryRef}
            showThumbnails={!globalFullscreen}
            useBrowserFullscreen={false}
            items={galleryItems}
            thumbnailPosition={
               isDesktop && !globalFullscreen ? 'left' : 'bottom'
            }
            showFullscreenButton={globalFullscreen}
            showPlayButton={false}
            aspect={'1:1'}
            thumbnailSizes={200}
            showBullets={globalFullscreen}
            onClick={handleFullscreen}
            renderFullscreenButton={(onClick, isFullscreen) => (
               <div
                  className="custom-fullscreen-btn"
                  onClick={handleFullscreen}
               >
                  {isFullscreen ? (
                     <Cancel
                        className="icon-shadow"
                        // height="2rem"
                        // width="2rem"
                        color="white"
                        strokeWidth={1.2}
                     />
                  ) : (
                     <OpenInWindow
                        className="icon-shadow"
                        color="white"
                        strokeWidth={1.7}
                     />
                  )}
               </div>
            )}
         />

         <div className="sticker-container d-flex gap-1">
            <div
               style={{ height: '0px' }}
               className="d-flex gap-1 flex-wrap flex-row"
            >
               {selectedChannelId == 1 && (
                  <img
                     className="price-runner"
                     src={`https://www.pricerunner.se/widget/cheapest/image/27997?sku=${activeVariant?.articleNumber}&width=200&lang=sv&1`}
                     alt="Billigast på Pricerunner"
                  />
               )}
               <PrisJaktWidget
                  artNr={activeVariant?.articleNumber}
                  selectedChannelId={selectedChannelId}
               />
            </div>
            {galleryItems &&
               onSale &&
               isProductPrebook(activeVariant) &&
               preBookCampaignSticker && (
                  <Link
                     className="d-flex flex-grow-1"
                     to={setLangLinkRoutes({
                        channelId: selectedChannelId,
                        sv: '/kampanjer',
                        dk: '/kampagner',
                        no: '/kampanjer',
                     })}
                  >
                     <img
                        className="img-fluid-height sticker-route-link"
                        alt="Campaign sticker"
                        src={preBookCampaignSticker}
                     />
                  </Link>
               )}
            {galleryItems &&
               onSale &&
               !isPackage &&
               !isProductPrebook(activeVariant) &&
               campaignSticker && (
                  <Link
                     className="d-flex flex-grow-1"
                     to={setLangLinkRoutes({
                        channelId: selectedChannelId,
                        sv: '/kampanjer',
                        dk: '/kampagner',
                        no: '/kampanjer',
                     })}
                  >
                     <img
                        className="img-fluid-height sticker-route-link"
                        alt="Campaign sticker"
                        src={campaignSticker}
                     />
                  </Link>
               )}
            {galleryItems && isNew && newSticker && (
               <Link
                  className="d-flex flex-grow-1"
                  to={setLangLinkRoutes({
                     channelId: selectedChannelId,
                     sv: '/nyheter',
                     dk: '/nyheder',
                     no: '/nyheter',
                  })}
               >
                  <img
                     className="img-fluid-height sticker-route-link"
                     alt="New sticker"
                     src={newSticker}
                  />
               </Link>
            )}
            {galleryItems && isPackage && packageSticker && (
               <div className="d-flex flex-grow-1">
                  <img
                     className="img-fluid-height"
                     alt="package sticker"
                     src={packageSticker}
                  />
               </div>
            )}
         </div>
      </ImageGalleryWrapper>
   ) : (
      <ProductPageImageSkeleton></ProductPageImageSkeleton>
   )
}

export default ProductImageGallery
